import React from 'react';
import s from './RHSLinkWidget.scss';
import Link from '../../../components/Link/Link';

const RHSLinkWidget = props => (
  <div className={s.rhsLinkWidget}>
    <div className={s.rhsLinkWidgetTitle}>{props.title}</div>

    <div className={s.linkWrap}>
      {props.items &&
        Array.isArray(props.items) &&
        props.items.length > 0 &&
        props.items.map((item, index) => (
          <Link href={item.wu} key={index}>
            {item.hl}
          </Link>
        ))}
    </div>
  </div>
);

export default RHSLinkWidget;
